/* eslint-disable no-underscore-dangle */
/* eslint-disable no-console */
import { useTranslate } from 'hooks/useTranslate';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import CustomLoading from 'modules/_shared/components/CustomLoading';
import PageListHeader from 'modules/_shared/components/Headers/PageListHeader';

import BoardCardPartner from 'modules/boards/components/BoardCardPartner';
import { useBoardsPartnerList } from 'modules/boards/hooks/useBoardsPartnerList';

import { useGetActualSociety } from 'hooks/useGetActualSociety';
import { useGetMenu } from 'modules/administratives/hooks/useGetMenu';
import Page from 'modules/_shared/components/Pages/Page';
import BoardListBanner from '../../components/BoardListBanner';

const BoardsPartnerList = () => {
  const { t } = useTranslate();
  const { societyId, memberId } = useParams();

  const user = useSelector((state) => state.user);
  const actualSociety = useSelector((state) => state.society?.actualSociety);

  const {
    data: boardsFiltered,
    partnerRepresentants,
    isLoading,
  } = useBoardsPartnerList(societyId, memberId, user);

  useGetMenu();
  useGetActualSociety(societyId);

  return (
    <Page id="boards-partner-list">
      <PageListHeader title={t('BoardCouncil')} />

      {boardsFiltered.map((board) => (
        <BoardCardPartner
          key={board?.['_id']}
          data={{
            ...board,
            society: actualSociety,
            societyId: actualSociety?.['_id'],
            user,
            partnerRepresentants,
          }}
        />
      ))}

      <div className={`nk-block ${boardsFiltered.length > 0 ? 'my-5' : ''}`}>
        <BoardListBanner />
      </div>

      {isLoading && <CustomLoading />}
    </Page>
  );
};

export default BoardsPartnerList;
